// SPDX-License-Identifier: GPL-3.0-or-later
import type { RoomName, RoomSnapshot } from '@ffb/shared';

export type { RoomName, RoomSnapshot };

export const ROOM_NAME_MIN = 3;
export const ROOM_NAME_MAX = 30;
export const USER_NAME_MIN = 1;
export const USER_NAME_MAX = 20;

// Разрешаем только те символы, из которых собирается peerId в signaling.
export const ROOM_NAME_PATTERN = /^[a-z0-9-]+$/;

export interface LobbyInput {
  userName: string;
  roomName: string;
}
